import Choices from 'choices.js';

export function choices(element: HTMLSelectElement) {
  return new Choices(element, {
    searchEnabled: false,
    removeItemButton: true,
    shouldSort: false,
    allowHTML: true,
    itemSelectText: 'Press',
  });
}

export function swiperColumns(columns: number) {
  return {
    786: { slidesPerView: Math.floor(columns / 2) },
    1024: { slidesPerView: columns },
  };
}
